<template>
	<div>
		<v-container fluid pa-0>
			<v-card elevation="0">
				<v-container fluid grid-list-xl class="toolbar-container">
					<v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
						<v-toolbar color="transparent" flat elevation="0">
							<v-toolbar-title class="ml-0"
								>{{ $t($route.meta.title) }}<bc-breadcrumbs :items="breadcrumb_items"></bc-breadcrumbs
							></v-toolbar-title>
							<v-spacer></v-spacer>
							<bc-tooltip class="hidden-sm-and-down">
								<template slot="activator">
									<v-btn icon @mouseup.left="exportToCsv">
										<v-icon>file_download</v-icon>
									</v-btn>
								</template>
								{{ $t("lang.export_to_csv") }}
							</bc-tooltip>
							<bc-btn-add v-if="hasPerm('subscriptions.create')" @invoke-method="invokeMethod($event)" action="openSubscriptionForm"></bc-btn-add>
							<bc-btn-refresh @invoke-method="dbGetSubscriptions()"></bc-btn-refresh>
							<bc-search-menu :params="axiosParams">
								<v-list>
									<v-list-tile>
										<bc-search-input v-model="filter.search" :params="axiosParams"></bc-search-input>
									</v-list-tile>
									<v-list-tile>
										<v-list-tile-action>
											<v-switch
												v-model="filter.is_online"
												color="success"
												:label="filter.is_online === '1' ? $t('lang.online') : $t('lang.offline')"
												true-value="1"
												false-value="0"
											></v-switch>
										</v-list-tile-action>
									</v-list-tile>
									<v-list-tile>
										<v-list-tile-action>
											<v-switch
												v-model="filter.has_subscription"
												color="success"
												label="Has Subscription"
												true-value="1"
												false-value="0"
											></v-switch>
										</v-list-tile-action>
									</v-list-tile>
								</v-list>
							</bc-search-menu>
						</v-toolbar>
					</v-layout>
				</v-container>

				<v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
					<v-data-table
						:headers="headers"
						:items="deviceSubscriptions"
						:no-data-text="$t('lang.no_results_matching')"
						class="br-table-7"
						hide-actions
					>
						<template slot="items" slot-scope="props">
							<tr class="clickable" @click="openSubscriptionForm(props.item)">
								<td class="text-center">{{ props.item.public_id }}</td>
								<td>{{ props.item.company_name }}</td>
								<td class="text-center">
									<v-icon :color="props.item.has_subscription == '1' ? 'success' : 'error'" large
										>check_circle</v-icon
									>
								</td>
								<td class="text-center">
									<v-icon :color="props.item.is_online == '1' ? 'success' : 'error'" large>check_circle</v-icon>
								</td>
								<td class="text-center">{{ props.item.expires }}</td>
							</tr>
						</template>
					</v-data-table>
				</v-card-text>
			</v-card>
		</v-container>
		<bc-dialog :value="subscription_dialog">
			<v-card>
				<v-form ref="form_subscription">
					<v-card-title>
						<span class="headline">{{ subscription.subscription_id ? $t("lang.edit_subscription") : $t("lang.add_subscription") }}</span>
						<v-spacer></v-spacer>
						<bc-btn-dialog-close
							@invoke-method="invokeMethod($event)"
							action="closeSubscriptionDialog"
							:dialog-status="subscription_dialog"
						></bc-btn-dialog-close>
					</v-card-title>
					<v-card-text>
						<v-container grid-list-form>
							<v-layout row wrap>
								<v-flex xs12>
									<bc-autocomplete
										v-model="subscription.device_id"
										:label="`${$t('lang.device')}`"
										:items="formattedDeviceOptions"
										item-value="device_id"
										item-text="displayText"
										:rules="ifValid('subscriptions.device_id')"
										:disabled="!(subscription.subscription_id === null)"
									></bc-autocomplete>
								</v-flex>
								<v-flex xs12>
									<v-text-field
										v-model="subscription.amount"
										:label="`${$t('lang.amount')} *`"
										:counter="showCounter(subscription.amount, 'subscriptions.amount')"
										:rules="ifValid('subscriptions.amount')"
										:disabled="!hasPerm('subscriptions.update')"
									></v-text-field>
								</v-flex>
								<v-flex xs12>
									<bc-select
										v-model="subscription.term_length"
										:label="`${$t('lang.term_length')} *`"
										:items="term_lengths"
										item-value="value"
										item-text="option"
										:rules="ifValid('subscriptions.term_length')"
										:disabled="!hasPerm('subscriptions.update')"
									></bc-select>
								</v-flex>
								<v-flex xs12>
									<bc-date-picker
										v-model="subscription.period_start"
										:label="`${$t('lang.period_start')} *`"
										:rules="ifValid('subscriptions.period_start')"
										:disabled="!hasPerm('subscriptions.update')"
									></bc-date-picker>
								</v-flex>

								<v-flex xs12>
									<v-checkbox
										v-model="subscription.is_verified"
										label="Verified"
										true-value="1"
										false-value="0"
										:rules="ifValid('subscriptions.is_verified')"
										:disabled="!hasPerm('subscriptions.update')"
									></v-checkbox>
								</v-flex>
							</v-layout>
						</v-container>
					</v-card-text>
					<v-card-actions>
						<v-btn
							v-if="subscription.subscription_id && hasPerm('subscriptions.delete')"
							color="error"
							@mouseup.left="$refs.delete_subscriptions.openDialog()"
							>{{ $t("lang.delete") }}
						</v-btn>
						<v-spacer></v-spacer>
						<v-btn flat @mouseup.left="closeSubscriptionDialog()">{{ $t("lang.cancel") }}</v-btn>
						<v-btn color="success" @click="saveSubscriptions" v-if="hasPerm('subscriptions.update')">{{ $t("lang.save") }}</v-btn>
					</v-card-actions>
				</v-form>
			</v-card>
		</bc-dialog>
		<delete-confirmation-dialog
			ref="delete_subscriptions"
			:heading="$t('lang.delete_subscription')"
			:message="$t('lang.confirm_delete_message')"
			@onConfirm="deleteSubscriptions(subscription.subscription_id)"
		></delete-confirmation-dialog>
	</div>
</template>

<script>
import { mapGetters, mapState, mapMutations, mapActions } from "vuex";
import { store } from "Store/store";
import httpClient from "Api/httpClient";

export default {
	data() {
		return {
			breadcrumb_items: [
				{
					text: "Dashboard",
					link: true,
					exact: true,
					disabled: false,
					to: {
						name: "dashboard",
					},
				},
				{
					text: "Configuration",
					link: true,
					exact: true,
					disabled: false,
					to: {
						name: "configuration",
						params: { tab: 1 },
					},
				},
				{
					text: "Device Subscriptions",
					disabled: true,
					href: "",
				},
			],

			headers: [
				{
					text: this.$t("lang.public_id_number"),
					sortable: false,
					width: "20%",
					align: "center",
				},
				{
					text: this.$t("lang.company"),
					sortable: false,
					width: "20%",
				},
				{
					text: this.$t("lang.has_subscription"),
					sortable: false,
					width: "20%",
					align: "center",
				},
				{
					text: this.$t("lang.is_online"),
					sortable: false,
					width: "20%",
					align: "center",
				},
				{
					text: this.$t("lang.expires_on"),
					sortable: false,
					width: "20%",
					align: "center",
				},
			],
			filter: {
				search: "",
				is_online: "0",
				has_subscription: "1",
			},
			dbGetSubscriptions: _.debounce(this.getSubscriptions, 1500, {
				maxWait: 1500,
				leading: true,
				trailing: false,
			}),
			subscription_dialog: false,
			subscription: {
				public_id: null,
				company: null,
				status: null,
				device_id: null,
				amount: null,
				term_length: null,
				period_start: null,
				period_end: null,
				is_verified: null,
				zoho_invoice_id: null,
				subscription_id: null,
			},
			enableAddModal: true,
			enableEditModal: true,
		};
	},
	beforeRouteEnter(to, from, next) {
		const filterDefaults = {
			is_online: "0",
			has_subscription: "1",
		};
		const mergedQuery = Object.assign({}, filterDefaults, to.query);
		store
			.dispatch("fetchSubscriptions", {
				body: mergedQuery,
				device_subscriptions: true,
			})
			.then((data) => {
				if (typeof data !== "undefined" && data.devices) {
					next((vm) => {
						vm.finishLoader();
					});
				}
				this.finishLoader();
				next();
			});
	},
	beforeRouteUpdate(to, from, next) {
		const filterDefaults = {
			search: "",
			is_online: "0",
			has_subscription: "1",
		};
		const mergedQuery = Object.assign({}, filterDefaults, to.query);
		this.$store
			.dispatch("fetchSubscriptions", {
				body: mergedQuery,
				device_subscriptions: true,
			})
			.then((data) => {
				if (typeof data !== "undefined" && data.devices) {
					this.setQuery(mergedQuery, this.filter, this.default_filter);
					this.finishLoader();
					next();
				}
				this.finishLoader();
				next();
			});
	},

	computed: {
		...mapState({
			default_filter: (state) => state.subscriptions.device_subscriptions_filter,
			deviceSubscriptions: (state) => state.subscriptions.device_subscriptions,
			rules_subscriptions: (state) => state.subscriptions.rules_subscriptions,
			subscription_status_options: (state) => state.settings.subscription_status_options,
			device_options: (state) => state.devices.device_options,
			term_lengths: (state) => state.options_categories.term_lengths,
		}),
		axiosParams() {
			return this.prepareParams(this.filter, this.default_filter);
		},
		formattedDeviceOptions() {
			return this.device_options.map((device) => ({
				...device,
				displayText: device.company
					? `${device.public_id} - ${device.company}` // Show device number and company
					: `${device.public_id}`, // Show only device number if company is null
			}));
		},
	},
	methods: {
		...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
		...mapActions(["fetchSubscriptions", "fetchSubscription", "saveSubscription", "deleteSubscription", "fetchCustomers", "fetchDevices", "fetchOptions"]),
		exportToCsv() {
			const headers = this.headers.filter((h) => h.text && h.text.trim() !== "").map((h) => h.text);

			// 2. Build rows from devices
			const rows = this.deviceSubscriptions.map((item) => [
				item.public_id,
				item.company_name,
				item.has_subscription == "1" ? this.$t("lang.yes") : this.$t("lang.no"),
				item.is_online == "1" ? this.$t("lang.yes") : this.$t("lang.no"),
				item.expires,
			]);

			// 3. Join into CSV format
			const csvContent = [
				headers.join(","), // first row: headers
				...rows.map((r) =>
					r
						.map((val) => {
							// Fallback: if val is null/undefined, use empty string
							const safeVal = val !== null && val !== undefined ? val : "";
							// Escape double quotes
							return '"' + safeVal.toString().replace(/"/g, '""') + '"';
						})
						.join(",")
				),
			].join("\n");

			// 4. Create a blob & trigger download
			const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
			const url = URL.createObjectURL(blob);
			const link = document.createElement("a");
			link.href = url;
			link.setAttribute("download", "device_subscriptions.csv");
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
			URL.revokeObjectURL(url);
		},
		getSubscriptions() {
			const filterDefaults = {
				is_online: "0",
				has_subscription: "1",
			};
			const mergedQuery = Object.assign({}, filterDefaults, this.filter);

			// Remove 'search' if empty
			if (!mergedQuery.search || mergedQuery.search.trim() === "") {
				delete mergedQuery.search;
			}

			this.startLoader();
			this.$store.dispatch("fetchSubscriptions", {
				body: mergedQuery,
				device_subscriptions: true,
			});
			this.finishLoader();
		},
		closeSubscriptionDialog() {
			this.subscription_dialog = false;
			this.subscription.subscription_id = null;
			this.$refs.delete_subscriptions.close();
			this.subscription = {};
			this.validationOff();
			this.toggleModalLoader(false);
		},
		openSubscriptionForm(item = null) {
			if (this.term_lengths.length <= 0) {
				this.fetchOptions({ body: { slug: "term_lengths" } });
			}
			if (this.device_options.length === 0) {
				this.fetchDevices({ body: { options: "1" } });
			}
			if (item != null) {
				// Get the subscription
				this.fetchSubscription({ subscription_id: item.subscription_id }).then((data) => {
					console.log(data);
				});
				if (item.subscription_id) {
					if (this.enableEditModal) {
						if (this.$refs.form_subscription) item ? this.$refs.form_subscription.resetValidation() : this.$refs.form_subscription.reset();

						this.$nextTick(() => {
							this.subscription = item != null ? this.assignObj2(item, this.rules_subscriptions) : {};
							this.subscription_dialog = true;
						});
					}
				} else {
					console.log("No subscription associated with this device.");
				}
			} else {
				this.subscription.subscription_id = null;
				if (this.enableAddModal) {
					if (this.$refs.form_subscription) item ? this.$refs.form_subscription.resetValidation() : this.$refs.form_subscription.reset();
					this.subscription_dialog = true;
				} else {
					this.$router.push({ name: "device_subscriptions" });
				}
			}
		},
		saveSubscriptions() {
			this.validationOn();
			this.$nextTick(() => {
				if (this.validateForm("form_subscription")) {
					let body = this.prepForm(this.subscription, this.rules_subscriptions);
					delete body["notes"];

					this.saveSubscription({
						body: body,
					}).then((data) => {
						if (data && data.code === 200) {
							this.subscription_dialog = false;
						}

						this.getSubscriptions();
					});
				}
			});
		},
	},
};
</script>
